var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c('Icon',{attrs:{"icon":"error"}}),_c('p',[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }